import React from "react";
import ReactDOM from "react-dom/client";
import "./boilderplate.css";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext"; // Adjust path
import { BrowserRouter as Router } from "react-router-dom";
import "@fontsource/lato";
import "@fontsource/lato/300.css"; //  Weight light 300
import "@fontsource/lato/400.css"; //  Weight light 400
import "@fontsource/lato/300-italic.css"; //  Weight thin italic 300

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLDivElement
);
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </React.StrictMode>
);
